export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';

export const openDialog = options => ({
  type: OPEN_DIALOG,
  payload: {
    data: options
  }
});

export const closeDialog = () => ({
  type: CLOSE_DIALOG
});



// WEBPACK FOOTER //
// ./src/redux/actions/dialogActions.js